import { useTranslation } from 'react-i18next';
import CustomDialog from 'components/custom-dialog/custom-dialog.component';
import SpreedlyCVVDialogContext from './spreedly-cvv-dialog.context';
import { useCallback, useContext } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { selectPaymentInstrumentById } from 'redux/user/user.selectors';
import { useSelector } from 'react-redux';
import { useCheckoutPaymentLoading } from 'pages/checkout/checkout.component';
import { NewPaymentContext } from 'components/payment/payment.context';
import SpreedlyCVVRecacheForm from '../forms/spreedly-cvv-recache-form/spreedly-cvv-recache-form.component';
import SpreedlyCVVGlobalErrors from './spreedly-cvv-global-errors/spreedly-cvv-global-errors.component';

const SpreedlyCVVDialog = () => {
  const { t } = useTranslation();
  const { handleClose, open, paymentInstrumentId, onSuccessRecacheCallback } =
    useContext(SpreedlyCVVDialogContext);
  const methods = useForm();
  const paymentInstrumentSelector = useCallback(
    state => selectPaymentInstrumentById(paymentInstrumentId)(state),
    [paymentInstrumentId],
  );
  const paymentInstrument = useSelector(paymentInstrumentSelector);
  const setPaymentLoading = useCheckoutPaymentLoading(
    state => state.setLoading,
  );
  const paymentLoading = useCheckoutPaymentLoading(state => state.loading);
  const paymentContext = useContext(NewPaymentContext);

  const onError = _errors => {
    setPaymentLoading(false);
  };

  const close = () => {
    methods.clearErrors();
    handleClose();
  };

  return (
    <CustomDialog
      title={t('checkout.payment.spreedly.cvvDialog.title')}
      open={open}
      close={close}
      testId="SpreedlyCVVDialog.CustomDialog"
    >
      {open && (
        <FormProvider {...methods}>
          <SpreedlyCVVRecacheForm
            paymentInstrument={paymentInstrument}
            initOrderAttributes={paymentContext?.initOrderResponse?.attributes}
            onSuccess={onSuccessRecacheCallback}
            onError={onError}
            setLoading={setPaymentLoading}
            isLoading={paymentLoading}
          />
          <SpreedlyCVVGlobalErrors />
        </FormProvider>
      )}
    </CustomDialog>
  );
};

export default SpreedlyCVVDialog;
